import { CarrierVisitDirection, UnloadingMethod } from '@planning/app/api'
import { FieldStore, ISubFormStore, validateSubForm } from '@tom-ui/utils'
import { action, computed, makeObservable } from 'mobx'
import { OogFormData } from './oog-helper'

export class OogSubFormStore implements ISubFormStore<OogFormData> {
  isOog: FieldStore<boolean>
  overLengthRear: FieldStore<number | undefined>
  overLengthFront: FieldStore<number | undefined>
  overWidthLeft: FieldStore<number | undefined>
  overWidthRight: FieldStore<number | undefined>
  overHeight: FieldStore<number | undefined>
  unloadingMethod: FieldStore<UnloadingMethod>
  direction?: CarrierVisitDirection

  constructor(initialValues?: Partial<OogFormData>) {
    makeObservable(this, {
      setDirection: action,

      isOogSelected: computed,
    })

    this.isOog = new FieldStore<boolean>(initialValues?.isOog ?? false)
    this.overLengthRear = new FieldStore<number | undefined>(
      initialValues?.overLengthRear ?? undefined,
    )
    this.overLengthFront = new FieldStore<number | undefined>(
      initialValues?.overLengthFront ?? undefined,
    )
    this.overWidthLeft = new FieldStore<number | undefined>(
      initialValues?.overWidthLeft ?? undefined,
    )
    this.overWidthRight = new FieldStore<number | undefined>(
      initialValues?.overWidthRight ?? undefined,
    )
    this.overHeight = new FieldStore<number | undefined>(initialValues?.overHeight ?? undefined)
    this.unloadingMethod = new FieldStore<UnloadingMethod>(
      initialValues?.unloadingMethod ?? UnloadingMethod.Standard,
    )
    this.direction = initialValues?.direction
  }

  setValues(data?: OogFormData) {
    this.isOog.setValue(data?.isOog ?? false)
    this.overLengthRear.setValue(data?.overLengthRear ?? undefined)
    this.overLengthFront.setValue(data?.overLengthFront ?? undefined)
    this.overWidthLeft.setValue(data?.overWidthLeft ?? undefined)
    this.overWidthRight.setValue(data?.overWidthRight ?? undefined)
    this.overHeight.setValue(data?.overHeight ?? undefined)
    this.unloadingMethod.setValue(data?.unloadingMethod ?? UnloadingMethod.Standard)

    if (data?.direction) this.setDirection(data.direction)
  }

  setDirection = (direction?: CarrierVisitDirection) => {
    if (this.direction !== direction) this.direction = direction
  }

  validate = () => {
    return validateSubForm(this)
  }

  get isOogSelected() {
    return this.isOog.value
  }

  get data() {
    if (!this.isOogSelected) {
      return {
        isOog: false,
      }
    }

    return {
      isOog: true,
      overLengthRear: this.overLengthRear.value ? this.overLengthRear.value : 0,
      overLengthFront: this.overLengthFront.value ? this.overLengthFront.value : 0,
      overWidthLeft: this.overWidthLeft.value ? this.overWidthLeft.value : 0,
      overWidthRight: this.overWidthRight.value ? this.overWidthRight.value : 0,
      overHeight: this.overHeight.value ? this.overHeight.value : 0,
      unloadingMethod: this.unloadingMethod.value,
    }
  }
}
